import {
  IField,
  IFormDocument,
  IListColumnInternalList,
} from 'app/services/api5-service/api.interface';

import { getLabel } from 'common/dynamic-form/wrappers/field-base/label/label.utils';
import { DocHelper } from 'utils/dochelper';

/**
 * Get list title
 *
 * @param field
 * @param doc - doc instance
 */
export function getListTitle(field: IField, doc: IFormDocument): string {
  return getLabel(field, doc);
}

/**
 * Get internal list title
 *
 * @param column
 * @param doc
 */
export function getInternalListTitle(
  column: IListColumnInternalList,
  doc: IFormDocument,
): string {
  return DocHelper.getMessage(`list_${column.$name}_title`, doc);
}
